import OpenableTitle from './OpenableTitle';
import { BottomDataWrapper, GroupItemDataWrapper, VerticalDivider } from './styles';
import ContentTypeTag from '../../components/AddContent/ContentTypeTag';
import { Space } from 'antd';
import { durationFromSecs } from 'utils/helpers';

interface IVideoItemData {
  data: any;
  onOpen?(): void;
}

const VideoItemData = ({ data, onOpen }: IVideoItemData): JSX.Element => {
  const { content_type, name, duration_in_seconds, instructor_name } = data;
  const duration = durationFromSecs(duration_in_seconds);

  return (
    <GroupItemDataWrapper>
      <Space>
        <ContentTypeTag value={content_type} />
      </Space>
      <OpenableTitle onOpen={onOpen}>{name}</OpenableTitle>
      <BottomDataWrapper>
        {instructor_name}
        {duration && (
          <>
            {instructor_name && <VerticalDivider />}
            {duration}
          </>
        )}
      </BottomDataWrapper>
    </GroupItemDataWrapper>
  );
};

export default VideoItemData;
